var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.26,
    height: 15.26,
    viewBox: "0 0 15.26 15.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_459",
    "data-name": "Trac\\xE9 459",
    d: "M346.137,300.408l1.338,1.36-3.366,3.311a1.575,1.575,0,0,1-1.116.46,1.593,1.593,0,0,1-1.126-.465l-1.765-1.711,1.327-1.369,1.56,1.512,3.148-3.1Zm5.438,2.587a7.63,7.63,0,1,1-7.63-7.63,7.639,7.639,0,0,1,7.63,7.63m-1.908,0a5.723,5.723,0,1,0-5.722,5.723,5.729,5.729,0,0,0,5.722-5.723",
    transform: "translate(-336.315 -295.365)",
    fill: "#1b394c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/valid.5e34c142125aed31f9f135f9c4a17e67.svg";
export { ForwardRef as ReactComponent };